
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.5 5.375a.75.75 0 00-.696.471l-2 5a.75.75 0 00-.054.279v5c0 .414.336.75.75.75h1.26a2.751 2.751 0 115.48 0h5.021a2.751 2.751 0 115.48 0H21.5a.75.75 0 00.75-.75v-3a2.75 2.75 0 00-2.75-2.75h-1.64l-3.774-4.719a.75.75 0 00-.586-.281h-9zm8.64 1.5l2.8 3.5h-3.69v-3.5h.89zm-2.39 0v3.5H3.608l1.4-3.5h5.742zM6.5 18.625a2 2 0 100-4 2 2 0 000 4zm12.5-2a2 2 0 11-4 0 2 2 0 014 0z"}})])
          )
        }
      }
    